import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as a from "react";
import { useState as G, useId as L, useEffect as M } from "react";
import { F as j } from "../index-EGJl6EpT.js";
import { u as z } from "../index-DoOsnuB6.js";
import { P as S, c as A } from "../index-D8UDu4KA.js";
import { a as K, c as I } from "../index-eoE_jzLb.js";
import { u as q } from "../index-BZPx6jYI.js";
import { u as F } from "../index-4vbonZJj.js";
import { P as T } from "../index-CRtCLpV2.js";
import { c as w } from "../clsx-OuTLNxxd.js";
import { L as X } from "../Label-Bj2Sx48J.js";
import '../Checkbox.css';var E = "Checkbox", [$] = A(E), [J, Q] = $(E), N = a.forwardRef(
  (e, s) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: h,
      defaultChecked: r,
      required: d,
      disabled: n,
      value: f = "on",
      onCheckedChange: b,
      form: p,
      ...v
    } = e, [l, C] = a.useState(null), y = z(s, (c) => C(c)), _ = a.useRef(!1), R = l ? p || !!l.closest("form") : !0, [m = !1, P] = K({
      prop: h,
      defaultProp: r,
      onChange: b
    }), D = a.useRef(m);
    return a.useEffect(() => {
      const c = l == null ? void 0 : l.form;
      if (c) {
        const x = () => P(D.current);
        return c.addEventListener("reset", x), () => c.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g(J, { scope: t, state: m, disabled: n, children: [
      /* @__PURE__ */ i(
        S.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(m) ? "mixed" : m,
          "aria-required": d,
          "data-state": H(m),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: f,
          ...v,
          ref: y,
          onKeyDown: I(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: I(e.onClick, (c) => {
            P((x) => u(x) ? !0 : !x), R && (_.current = c.isPropagationStopped(), _.current || c.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ i(
        U,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: f,
          checked: m,
          required: d,
          disabled: n,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(r) ? !1 : r
        }
      )
    ] });
  }
);
N.displayName = E;
var O = "CheckboxIndicator", B = a.forwardRef(
  (e, s) => {
    const { __scopeCheckbox: t, forceMount: o, ...h } = e, r = Q(O, t);
    return /* @__PURE__ */ i(T, { present: o || u(r.state) || r.state === !0, children: /* @__PURE__ */ i(
      S.span,
      {
        "data-state": H(r.state),
        "data-disabled": r.disabled ? "" : void 0,
        ...h,
        ref: s,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = O;
var U = (e) => {
  const { control: s, checked: t, bubbles: o = !0, defaultChecked: h, ...r } = e, d = a.useRef(null), n = q(t), f = F(s);
  a.useEffect(() => {
    const p = d.current, v = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (n !== t && C) {
      const y = new Event("click", { bubbles: o });
      p.indeterminate = u(t), C.call(p, u(t) ? !1 : t), p.dispatchEvent(y);
    }
  }, [n, t, o]);
  const b = a.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: h ?? b.current,
      ...r,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function H(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var V = N, W = B;
const Y = "_checkbox_ihrtn_32", Z = "_shouldHighlightOnChecked_ihrtn_32", ee = "_checked_ihrtn_32", te = "_checkboxBox_ihrtn_53", oe = "_indicator_ihrtn_64", re = "_checkboxGroup_ihrtn_83", k = {
  checkbox: Y,
  shouldHighlightOnChecked: Z,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: re
}, pe = ({ children: e, className: s, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: w(k.checkboxGroup, s),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), me = ({
  checked: e,
  children: s,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: h = !0,
  ...r
}) => {
  const [d, n] = G(e), f = L();
  return M(() => {
    n(e);
  }, [e]), /* @__PURE__ */ g(
    X,
    {
      className: w(
        k.checkbox,
        {
          [k.checked]: d,
          [k.shouldHighlightOnChecked]: h
        },
        t
      ),
      id: f,
      children: [
        /* @__PURE__ */ i(
          V,
          {
            "aria-labelledby": f,
            ...r,
            checked: d,
            className: k.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), n(b);
            },
            children: /* @__PURE__ */ i(W, { className: k.indicator, children: /* @__PURE__ */ i(j, { color: "blue", size: "s" }) })
          }
        ),
        s
      ]
    }
  );
};
export {
  me as Checkbox,
  pe as CheckboxGroup
};
